<template>
  <div>
    <v-card outlined>
      <v-card-title class="d-flex justify-space-between align-center" style="padding-bottom: 10px !important">
        <app-title> Configurações de Prontuário </app-title>
        <v-btn rounded color="primary" @click="handleNewDocument()">
          <v-icon left> mdi-plus </v-icon>
          Novo
        </v-btn>
      </v-card-title>

      <v-card-text class="px-3">
        <v-row no-gutters>
          <template v-for="(professional_record, index) in professional_records">
            <v-col cols="4" class="pa-3" :key="index">
              <v-card class="pa-5" outlined>
                <div class="d-flex justify-space-between align-center professional_record-name">
                  <span>{{ professional_record.name }}</span>
                  <v-btn icon small @click="handleEditDocument(professional_record.id)">
                    <v-icon center> mdi-pencil </v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      professional_records: [],
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    handleEditDocument(document_id) {
      this.$router.push(`/configuracoes/prontuario/${document_id}`);
    },

    handleNewDocument() {
      this.$router.push(`/configuracoes/prontuario/novo`);
    },

    select(page = 1) {
      this.$http.index("professional-record/professional-record", { page: page }).then((response) => {
        this.professional_records = response.professional_records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.professional_record-name {
  color: #33303e;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
</style>